import { useReducer } from 'react';

enum StateActionType {
  UPDATE_FIELD = 'UPDATE_FIELD',
  RESET = 'RESET',
}

export type IUpdater<T> = Partial<T> | ((prev: T) => Partial<T>);

type Action<T> = { type: StateActionType.UPDATE_FIELD; value: IUpdater<T> } | { type: StateActionType.RESET };

const useStateReducer = <T>(initialState: T) => {
  const formReducer = (state: T, action: Action<T>): T => {
    switch (action.type) {
      case StateActionType.UPDATE_FIELD: {
        const partial = typeof action.value === 'function' ? action.value(state) : action.value;

        return { ...state, ...partial };
      }

      case StateActionType.RESET:
        return initialState;

      default:
        return state;
    }
  };

  const [state, dispatch] = useReducer(formReducer, initialState);

  const updateState = (value: IUpdater<T>) => dispatch({ type: StateActionType.UPDATE_FIELD, value });

  const resetState = () => dispatch({ type: StateActionType.RESET });

  return {
    state,
    stateDispatch: dispatch,
    updateState,
    resetState,
  };
};

export default useStateReducer;
